import { Divider } from 'antd';
import { useUnit } from 'effector-react';
import style from './ABStyles.module.css';
import {
  $ABGradient,
  $activeLayer,
} from '../../models/ABMarketsModel/index.js';

function AbLegend() {
  const gradient = useUnit($ABGradient);
  const { buckets, colors } = gradient;
  const activeLayer = useUnit($activeLayer);

  return (
    <div className={style.ab_legend}>
      <div className={style.legend_items_wrapper}>
        {buckets.map((item, index) => {
          return (
            <div className={style.legend_item} key={`legend-${index}`}>
              <div
                style={{ background: colors[index] }}
                className={style.legend_color}
              />
              <div>
                {`${item}${activeLayer === 'tariff' ? '%' : ''}`}
                {buckets[index + 1]
                  ? ` - ${buckets[index + 1]}${
                      activeLayer === 'tariff' ? '%' : ''
                    }`
                  : ' <'}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default AbLegend;
